import React from 'react'
import { Link } from 'react-router-dom'
import "./header.scss"
function Header() {
  return (
    <header>

            <a className='logo' ><img src={require("../images/logo.png")} alt="" /></a>
   
        <ul>
            <Link to="/">الصفحة الرئيسية</Link>
            <Link to="/contact">تواصل معنا</Link>
            <Link to="/about">حول مكتبنا</Link>
        </ul>
    </header>
  )
}

export default Header